import { __assign } from "tslib";
import React from 'react';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
import InternalRadioGroup from './internal';
export default function RadioGroup(props) {
    var baseComponentProps = useBaseComponent('RadioGroup');
    return React.createElement(InternalRadioGroup, __assign({}, props, baseComponentProps));
}
applyDisplayName(RadioGroup, 'RadioGroup');
//# sourceMappingURL=index.js.map